// eslint-disable-next-line no-use-before-define
import React, { useState, useEffect } from "react";
// import { formValueSelector, reduxForm } from "redux-form";
import { connect, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { authLogin, languageChange } from "./auth.actions";
import { LoadingSpinner } from "../../Layout/LoadingSpinner";
import "./Login.css";
import { Show } from "../../Layout";
import 'bootstrap/dist/css/bootstrap.min.css';
import FacebookSignIn from "./facebookSignin";
import { MobileLogin } from "./MobileLogin";
import Language from "../../Languages/Login/content.json"
import { Helmet } from "react-helmet";
import { ForgetPasswordEmailWithState } from "./ForgetPasswordEmailForm";
import { registerDict } from 'Languages/RegistrationTranslations';
import facebookImage from '../../assets/img/facebook2.png';
import signUpImg from '../../assets/img/forwardarrow.png';

function Login(props) {
  const dispatch = useDispatch();
  const [username, setUsername] = useState({ username: null });
  const [password, setPassword] = useState({ password: null });
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [referralId, setReferralId] = useState('');
  const [showFacebookSignIn, setShowFacebookSignIn] = useState(false);
  const [captcha, setCaptcha] = useState(true);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const history = useHistory();
  // const { invalid, submitting } = props;
  const pageContents = props.language === 'hi' ? Language.LoginHindi : Language.LoginEnglish
  const lang = props.language ?? 'en';
  const handleContinueWithFacebookClick = () => {
    setShowFacebookSignIn(true);
  };



  useEffect(() => {
    const url = window.location.href;
    let lang = url.split('=')[1];
    if (lang !== undefined) {
      let urlLang = lang;
      setTimeout(() => {
        dispatch(languageChange(urlLang))
      }, 800);
    }
  }, [dispatch])

  useEffect(() => {
    const hash = window.location.hash;
    const regex = /referralId=([^&]*)/;
    const referralIdMatch = regex.exec(hash);
    const referralId = referralIdMatch ? referralIdMatch[1] : null;
    setReferralId(referralId)
  }, []);

  const onSubmit = (e) => {
    if (e) e.preventDefault();
    props.authLogin(
      username.username,
      password.password,
      'password',
      props.language,
      history
    );
  }

  // Surface login failures as a red toast on every submit attempt. The thunk
  // is fire-and-forget (no .catch reaches this component) — errors land in
  // Redux as props.authError. The freshness signal is `props.authErrorAt`
  // (a Date.now() timestamp written by the AUTH_FAIL reducer case) because
  // Login can unmount/remount mid-submit (parent loading-spinner swap), which
  // would reset any local nonce state to 0 and silently skip the toast.
  // Redux state survives the remount; the timestamp changes on every failure
  // so identical error strings still trigger a fresh toast.
  useEffect(() => {
    if (!props.authErrorAt || !props.authError) return;
    let message;
    if (props.language === 'hi' && props.authError === 'User Not found.') {
      message = 'उपयोगकर्ता मौजूद नहीं।';
    } else if (props.language === 'hi' && props.authError === 'Invalid Password!') {
      message = 'गलत पासवर्ड।';
    } else if (props.authError === 'User Not found.') {
      message = 'User not registered with this email';
    } else if (props.authError === 'Invalid Password!') {
      message = 'Incorrect password';
    } else {
      message = props.authError || 'Login failed. Please check your credentials and try again.';
    }
    toast.error(message);
  }, [props.authErrorAt]);


  const handleClick = () => {
    if (referralId) {
      const queryParams = {
        referralId: referralId,
      };
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
      const loginUrl = `/auth/signup?${queryString}`;
      history.push(loginUrl)
    } else {
      history.push('/auth/signup')
    }
  };

  const conditionalVarObj = {
    true: {
      "mainCardPadding": "p-3",
      "headerImgWidth": "30%",
      "allParagraph": '20px',
      "allVisibleBtn": "25px",
      "partition": "या",
      "inputPIcon": "fa fa-eye-slash",
      "newUserPadding": "0.3rem",
      "fbText": "फेसबुक से जुड़ें",
      "inputPType": "text",
    },
    false: {
      "mainCardPadding": "p-2",
      "headerImgWidth": "13%",
      "allParagraph": '16px',
      "allVisibleBtn": "16px",
      "partition": "OR",
      "inputPIcon": "fa fa-eye",
      "newUserPadding": "0.1rem",
      "fbText": "Connect with facebook",
      "inputPType": "password",
    },
  }

  return (
    <>
      <Helmet>
        <title>DataXing - Sign in</title>
      </Helmet>
      <section className="formSec">
        {/* Header zone — in-flow at the top of the .formSec flex column. */}
        <div className="w-100">
          <div className='w-100 mb-2' style={{ boxShadow: "0px 2px 3px 1px rgba(0, 0, 0, 0.5), 4px 0px 12px 0px rgba(0, 0, 0, 0.5)" }}>
            <div className={`card ${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["mainCardPadding"]}`} style={{ backgroundColor: "#1b1b1e" }}>
              <div className="d-flex align-items-center justify-content-center">
                <img src={process.env.PUBLIC_URL + '/DX Logo.avif'} className="" alt="DataXing" style={{ width: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["headerImgWidth"]}`, maxHeight: '60px', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
        </div>
        {/* Card zone — takes the remaining viewport height and vertically
            centers its single child via column-flex + justify-content: center. */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div className="container zoom-70">
          <div className="row" style={{ paddingTop: '2%' }}>
            <div className="col-sm-12 col-md-5 col-lg-5 m-0 m-auto">
              <div className="card card-body pt-1 mb-5 shadow" style={{ backgroundColor: "#1b1b1e", borderTop: "3rem solid #BF0505", borderRadius: "0.75rem", color: "#fff" }}>
                <h3 style={{ color: "#fff", fontWeight: "700", opacity: "1", textAlign: "center", marginTop: "1rem", marginBottom: "1.25rem" }}>{pageContents.items[0].title}</h3>
                {/* Hidden — admin portal does not allow self-signup. "New user? Create an account" link.
                    JSX commented out (handleClick handler left intact for possible re-enable). */}
                {/* <p style={{ color: "#a0a0a0", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allParagraph"]}` }}>{pageContents.items[1].title}<Link to="#" onClick={handleClick} className="text-white" style={{ backgroundColor: "#BF0505", borderRadius: "0.5rem", textDecoration: "none", padding: `${conditionalVarObj[lang === "hi"]["newUserPadding"]} 0.5rem 0.3rem 0.5rem` }}>{pageContents.items[2].title}</Link></p> */}
                {/* Hidden — admin portal does not allow OTP login. "Sign in with mobile OTP" button + its
                    MobileLogin modal mount. JSX commented out (isMobile/setIsMobile state + MobileLogin
                    import left intact for possible re-enable). */}
                {/* <div className="social-login">
                  <button
                    type="button"
                    style={{ width: "100%", borderRadius: "1rem", backgroundColor: "#BF0505", color: "#fff", padding: "0.7rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                    onClick={() => setIsMobile(true)}
                  >
                    <span>
                      {pageContents.items[9].title}
                    </span>
                  </button>

                  {isMobile && <MobileLogin
                    referralId={referralId}
                    show={isMobile}
                    onClose={() => setIsMobile(false)}
                    onSubmit={() => {
                      setIsMobile(false)
                    }
                    }
                  />}
                </div> */}
                {/* Hidden — "OR" separator below the OTP button (would be orphaned with the OTP button hidden). */}
                {/* <div>
                  <p className="text-center mt-2" style={{ color: "#a0a0a0", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allparagraph"]}` }}>{conditionalVarObj[lang === "hi"]["partition"]}</p>
                </div> */}
                <form onSubmit={onSubmit}>
                  <div className="mb-4">
                    <input
                      data-lang={lang}
                      maxLength={200}
                      type="email"
                      className="form-control"
                      name="email"
                      onChange={(e) => {
                        e.target.setCustomValidity("")
                        setUsername({ username: e.target.value })
                      }
                      }
                      required
                      title={registerDict[lang]['correct_email_format']}
                      pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                      onInput={(e) => e.target.setCustomValidity("")}
                      onInvalid={(e) => {
                        let msg = registerDict[lang]['correct_email_format'];
                        e.target.setCustomValidity(msg)
                      }}
                      style={{ border: "1px solid #3a3a3e", borderRadius: "0.75rem", backgroundColor: "#2a2a2e", color: "#fff", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                      placeholder={pageContents.items[4].title}
                    />
                  </div>
                  <div className="mb-5" style={{ position: 'relative', }}>
                    <input data-lang={lang} className="form-control" name="pswd" onChange={(e) => {
                      e.target.setCustomValidity("")
                      setPassword({ password: e.target.value })
                    }
                    }
                      title={registerDict[lang]['password_required']}
                      type={conditionalVarObj[isPasswordVisible]["inputPType"]}
                      onInput={(e) => e.target.setCustomValidity("")}
                      onInvalid={(e) => {
                        let msg = registerDict[lang]['validationMessage'] + ': ' + registerDict[lang]['password_required']
                        e.target.setCustomValidity(msg)
                      }}
                      style={{ border: "1px solid #3a3a3e", borderRadius: "0.75rem", backgroundColor: "#2a2a2e", color: "#fff", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                      placeholder={pageContents.items[5].title}
                      autoComplete="new-password"
                      required />
                    <button
                      className={password.password ? "bg-transparent" : "d-none"}
                      type="button"
                      style={{ position: 'absolute', top: '50%', backgroundColor: "transparent", color: "#a0a0a0", right: '10px', transform: 'translateY(-50%)' }}
                      onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                    >
                      <i className={conditionalVarObj[!isPasswordVisible]["inputPIcon"]}></i>
                    </button>
                  </div>
                  {/* <GoogleReCaptcha
                    onCaptchaValidation={handleCaptchaValidation}
                  /> */}
                  <Show when={true}>
                    <button type="button" className='bg-transparent' onClick={(e) => setIsPasswordReset(true)} style={{ color: "#BF0505", fontWeight: "bold", marginLeft: "1rem", cursor: "pointer", textDecoration: "none", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allparagraph"]}` }}>
                      {pageContents.items[6].title}
                    </button>
                  </Show>
                  <div className="mt-5">
                    <LoadingSpinner show={props.isLoading} />
                    <Show when={true}>
                      {props?.error?.message ?? ''}
                    </Show>
                    <span className="text-right">
                      <button
                        type="submit"
                        style={{ float: 'right', borderRadius: "1.5rem", backgroundColor: "#BF0505", color: "#fff", paddingLeft: "16px", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allparagraph"]}` }}
                        className=""
                        disabled={captcha === false}
                      >
                        <span style={{ display: "flex", alignItems: "center" }}>
                          {pageContents.items[7].title} &nbsp;<img src={signUpImg} className="" alt="DataXing" width={"20rem"} />
                        </span>
                      </button>
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>
      <ForgetPasswordEmailWithState
        show={isPasswordReset}
        onHide={() => setIsPasswordReset(false)}
        onClose={() => setIsPasswordReset(false)}
      />
    </>

  );
}

Login.propTypes = {
  authLogin: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  authError: PropTypes.string,
  language: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    isAuth: state.adminUser.adminUser.isAuthenticated,
    token: state.adminUser.adminUser.token,
    state: state,
    language: state.adminUser.adminUser.language,
    isLoading: state.adminUser.adminUser.loading,
    authError: state.adminUser.adminUser.error,
    authErrorAt: state.adminUser.adminUser.errorAt,
  };
};

const LoginWithState = connect(mapStateToProps, { authLogin })(Login);

export { Login, LoginWithState };
